module.exports = __webpack_public_path__ + "0248004f36af5b9951d3db76e082f490.svg";